export default "/images/sponsor2.jpg?062bb7cd09bdc9fcfcf4ef0fdefbfe51";